import {TabContent} from '../TabContent'

export const OtherMapper = ({data}) => {
  return <TabContent tab={'other'} data={data} />
}
